import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import { PartialId } from '@attain-apps/string-builder'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import * as common from '../../../../../common'

export const DOC = gql`
  query AgentChatConversations(
    $tenantId: ID!
    $zoneId: ID!
    $agentId: String!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        agentChatConversations(agentId: $agentId) {
          id
          createdAt
          name
          agentId
          ownerId
          sharedWith
          workspaceId
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.AgentChatConversationsQuery,
    readonly ents.core.agent.Conversation[],
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'agentChatConversations',
        graphql.transformers.OUT.list(
          graphql.transformers.OUT.object({
            agentId: graphql.transformers.OUT.nonNull(
              common.gql.enums.agentId.TRANSFORMER,
            ),
            createdAt: graphql.transformers.OUT.validate(
              graphql.transformers.AWS_SCALARS.datetime,
              TypeAsserter.assertIsNotNullish,
              { warnOnly: true },
            ),
            id: graphql.transformers.OUT.validate(
              transformers.PASS_THROUGH,
              TypeAsserter.assertIsNotNullish,
            ),
            name: graphql.transformers.OUT.default(
              transformers.PASS_THROUGH,
              'Unnamed Conversation',
            ),
            ownerId: graphql.transformers.OUT.validate(
              transformers.PASS_THROUGH,
              TypeAsserter.assertIsNotNullish,
            ),
            sharedWith: graphql.transformers.OUT.default(
              graphql.transformers.OUT.list(transformers.PASS_THROUGH),
              [],
            ),
            workspaceId: {
              usingFullInput: graphql.transformers.OUT.select(
                'workspaceId',
                graphql.transformers.OUT.validate(
                  transformers.PASS_THROUGH,
                  TypeAsserter.Factory.from(
                    TypeChecker.Factory.optional(PartialId.isPartialId),
                  ),
                ),
              ),
            },
          }),
          { onNullish: 'remove' },
        ),
      ),
    ),
  ),
  [],
)

export const executor = graphql.createExecutor<
  graphql.schema.AgentChatConversationsQuery,
  readonly ents.core.agent.Conversation[],
  graphql.schema.AgentChatConversationsQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
